import { Injectable, InjectionToken } from '@angular/core';
import { BrowserPlatformService } from 'src/@services/browser-platform.service';

export interface ReportDownloadPort {
  openBlobInNewTab(blob: Blob): void;
  downloadBlob(blob: Blob, fileName: string): void;
}

export const REPORT_DOWNLOAD_PROVIDER = new InjectionToken<ReportDownloadPort>(
  'REPORT_DOWNLOAD_PROVIDER'
);

@Injectable({
  providedIn: 'root',
})
export class BrowserReportDownloadAdapter implements ReportDownloadPort {
  constructor(private browserPlatformService: BrowserPlatformService) {}

  openBlobInNewTab(blob: Blob): void {
    const fileUrl = this.browserPlatformService.createObjectUrl(blob);
    this.browserPlatformService.openInNewTab(fileUrl);
    this.browserPlatformService.revokeObjectUrl(fileUrl);
  }

  downloadBlob(blob: Blob, fileName: string): void {
    const downloadUrl = this.browserPlatformService.createObjectUrl(blob);
    this.browserPlatformService.downloadBlob(downloadUrl, fileName);
    this.browserPlatformService.revokeObjectUrl(downloadUrl);
  }
}
